export default __webpack_public_path__ + "static/media/Ballroll_00193.a9f73e73.png";